import { Box, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getModificationPriorTableRows } from "./quotaModificationUtils";
import {
   Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize, IconButton, useMediaQuery,
} from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import { useTheme } from "@mui/material/styles";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CollapseSection from "../../../components/ui/CollapseSection";
import muiConfig from '../../../assets/MuiConfig.json'

const DisplayComments = (params) => {
   const [displayComments, setDisplayComments] = useState("");
   const [userComments, setUserComments] = useState("");
   const [open, setOpen] = useState(false);
   const desiredcolor =
       params?.comments?.length > 0 &&
           params?.comments != "Default Customer quota record"
           ? "blue"
           : "black";

   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

   const handleClose = () => {
       setOpen(false);
   };

   return (
       <>
           <IconButton
               onClick={() => setOpen(true)}
               title={params.comments}
           >
               {params?.comments ? (
                   <ForumOutlinedIcon title={params.comments} sx={{ color:"darkred.light" }}/>
               ) : (
                   <ForumOutlinedIcon />
               )}
           </IconButton>

           <Dialog
               disableEnforceFocus
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
           >
               <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
               <DialogContent>
                   <DialogContentText>
                       <TextareaAutosize
                           onChange={(event) => setUserComments(event.target.value)}
                           aria-label="minimum height"
                           minRows={5}
                           readOnly
                           placeholder=""
                           style={{ width: 500, fontSize: 18 }}
                           defaultValue={params.comments}
                       />
                   </DialogContentText>
               </DialogContent>
               <DialogActions>
                   <Button
                       variant="outlined"
                       onClick={handleClose}
                       size="small"
                       sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": {
                          bgcolor: "darkred.main",
                          color: "white.main",
                        },
                      }}
                   >
                       Cancel
                   </Button>
               </DialogActions>
           </Dialog>
       </>
   );
};
function getModificationPriorTableCols(depletionModel) {
   const w = 150;
   if(depletionModel?.toLowerCase() === "none" ){
   const columns = [
      { field: "modificationNo", headerName: "Modification No",flex:1 },
      { field: "customerName", headerName: "Customer/CG", flex:1 },
      { field: "number", headerName: "Customer Number", flex:1 },
      { field: "skuName", headerName: "SKU/PG", flex:1 },
      { field: "skuNumb", headerName: "SKU Number",flex:1 },
      { field: "modification1", headerName: "Quota", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modificationComments", headerName: "Comments",flex:1 ,
      renderCell: (cellValues) => {
         return <DisplayComments readonly comments={cellValues.value} />;
      },},
   ];
   return columns;
   }else if(depletionModel?.toLowerCase() === "biweekly" ){
   const columns = [
      { field: "modificationNo", headerName: "Modification No", flex:1 },
      { field: "customerName", headerName: "Customer/CG", flex:1 },
      { field: "number", headerName: "Customer Number", flex:1 },
      { field: "skuName", headerName: "SKU/PG", flex:1 },
      { field: "skuNumb", headerName: "SKU Number", flex:1 },
      { field: "modification1", headerName: "First Half", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modification2", headerName: "Second Half", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
      { field: "modificationComments", headerName: "Comments", flex:1 ,
      renderCell: (cellValues) => {
         return <DisplayComments readonly comments={cellValues.value} />;
      },},
   ];
   return columns;
   }else{
      const columns = [
         { field: "modificationNo", headerName: "Modification No", flex:1 },
         { field: "customerName", headerName: "Customer/CG", flex:1 },
         { field: "number", headerName: "Customer Number", flex:1 },
         { field: "skuName", headerName: "SKU/PG", flex:1 },
         { field: "skuNumb", headerName: "SKU Number", flex:1 },
         { field: "modification1", headerName: "Week 1", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
         { field: "modification2", headerName: "Week 2", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
         { field: "modification3", headerName: "Week 3", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
         { field: "modification4", headerName: "Week 4", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
         { field: "modification5", headerName: "Week 5", flex:1, align : 'center', headerAlign : 'center',
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
         } },
         { field: "modificationComments", headerName: "Comments", flex:1 ,
         renderCell: (cellValues) => {
            return <DisplayComments readonly comments={cellValues.value} />;
         },},
      ];
      return columns;
   }
  
}

export default function ModificationPriorTable() {
   const state = useSelector((store) => store.quotaModification);
   const { scenarioModificationList, selectedRows, displayModifiedRecords,scenarioName, selectedModificationNumber } = state;
   const [isAll, setIsAll] = useState(false); 
   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0,
   });

   if(scenarioModificationList === null) return null;

   // const rows = getModificationPriorTableRows(
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersPriorChanges,
   //    scenarioModificationList[selectedRows[selectedRows.length - 1]].modificationCustomersLatestChanges,
   //    displayModifiedRecords
   // );
   let modificationNo = ""
   if(selectedModificationNumber === null || selectedModificationNumber === undefined ||selectedModificationNumber === ""){
      modificationNo = scenarioModificationList[0].modificationNo 
   }else{
      modificationNo = selectedModificationNumber;
   }
   const rows = getModificationPriorTableRows(
      scenarioModificationList[0].modificationCustomersPriorChanges,
      scenarioModificationList[0].modificationCustomersLatestChanges,
      displayModifiedRecords, modificationNo
   );
   const columns = getModificationPriorTableCols(scenarioModificationList[0].depletionModel);
   const title = `Quota of : ${scenarioName}`

   const setModal = (newPaginationModel) => {
      if(newPaginationModel.pageSize === muiConfig.DataGrid_All && newPaginationModel.page === 0 && rows?.length > 100){
      setIsAll(true);
      }else{
      setIsAll(false);
      }
      setPaginationModel(newPaginationModel);  
   }
   return (
      <Box sx={{ mt: 3 }}>
         {/* <div>
            <Typography className="compHeading" sx={{mb: 2, mt: 4,fontWeight:600, }}>Quota of: {scenarioName}</Typography>
         </div> */}
         <CollapseSection title={title}>
         <DataGridPro //style={{ maxHeight: 'calc(100vh - 130px)'}}
            rows={rows}
            columns={columns}
            disableColumnMenu
            initialState={{
					pagination: { paginationModel: { pageSize:20, page:0 }}
				}}
				pagination
				pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
            paginationModel={paginationModel}
            onPaginationModelChange = {setModal}	
            headerHeight={40} 
            sx={{
               ...(!isAll ? {
                  "& .MuiDataGrid-virtualScroller": {
                     maxHeight: "unset !important"
                  }
                } : {
                  "& .MuiDataGrid-virtualScroller": {
                     maxHeight: "80vh !important"
                  }
               })
				}}
         />
         </CollapseSection>
      </Box>
   );
}
